/**
 * Single source of truth for local cart V1 vs V2 shape handling.
 * Use these helpers everywhere instead of duplicating type guards and payload logic.
 */
import { ILocalCart, ILocalCartResponseV2 } from "@dineout-cart-client/interfaces/LocalCart";

/** Union type for "cart that might be flat (V1) or wrapped (V2)" */
export type LocalCartLike = ILocalCart | ILocalCartResponseV2 | null;

/** Type guard: true when cart has V2 shape { localCart: ILocalCart, ... } */
export const isLocalCartResponseV2 = (cart: LocalCartLike | null | undefined): cart is ILocalCartResponseV2 =>
    cart != null && "localCart" in cart && typeof (cart as ILocalCartResponseV2).localCart === "object";

/**
 * Normalize to flat cart (inner cart). Use whenever you need ILocalCart regardless of V1/V2.
 */
export const toFlatLocalCart = <T extends LocalCartLike>(cart: T): ILocalCart =>
    isLocalCartResponseV2(cart) ? cart.localCart : (cart as ILocalCart);
